import React, { useState } from "react";

interface KgGraphPopupProps {
  graphData?: any;
}

const KgGraphPopup: React.FC<KgGraphPopupProps> = ({ graphData }) => {
  const [activeTab, setActiveTab] = useState("people");
  const people = graphData?.people || [];
  const documents = graphData?.documents || [];
  const processes = graphData?.process || [];

  return (
    <div className="graph-popup-box">
      <div className="graph-tabs">
        <button className={`graph-tab people-${activeTab === "people" ? "active" : ""}`} onClick={() => setActiveTab("people")}>
          People ({people.length})
        </button>
        <button className={`graph-tab documents-${activeTab === "documents" ? "active" : ""}`} onClick={() => setActiveTab("documents")}>
          Documents ({documents.length})
        </button>
        <button className={`graph-tab process-${activeTab === "process" ? "active" : ""}`} onClick={() => setActiveTab("process")}>
          Process ({processes.length})
        </button>
      </div>

      <div className="graph-tab-contents">
        {activeTab === "people" && people.map((person: any, index: number) => (
          <div className="graph-tab-content" key={person.name || index}>
            <div className="graph-header">
              <span className="name">{person.name}</span>
              <span className="position">{person.position}</span>
            </div>
            <div className="graph-subHeader">
              {person.email && <span>{person.email}</span>}
              {person.slack && <span>Slack: {person.slack}</span>}
              {person.teams && <span>Teams: {person.teams}</span>}
            </div>
            {person.specializations?.length > 0 && (
              <div className="graph-specializations">
                <img className="icon-small" src="/svg/star.svg" alt="Specializations" />
                <span>{person.specializations.join(", ")}</span>
              </div>
            )}
          </div>
        ))}

        {activeTab === "documents" && documents.map((document: any, index: number) => (
          <div className="document-entry" key={document.name || index}>
            <div className="flex-row gap-8">
              <a href={document.url || "#"} target="_blank" rel="noopener noreferrer">{document.name}</a>
              {document.version && <span className="document-meta">({document.version})</span>}
              {document.updated && <span className="document-meta">Updated: {document.updated}</span>}
            </div>
            {document.owner && <div className="document-owner">Owner: {document.owner}</div>}
            {document.tags?.length > 0 && (
              <div className="flex-row gap-6">
                <img className="icon-small" src="/svg/star.svg" alt="Tags" />
                <span>{document.tags.join(", ")}</span>
              </div>
            )}
          </div>
        ))}

        {activeTab === "process" && processes.map((process: any, index: number) => (
          <div className="graph-tab-content process-entry" key={process.name || index}>
            <span className="process-name">{process.name}</span>
            {process.owner && <span className="process-owner">Owner: {process.owner}</span>}
            {process.linked_systems?.length > 0 && <span>Linked Systems: {process.linked_systems.join(", ")}</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default KgGraphPopup;